import { logActivity } from './logActivity';
import Service from './service';

const UPLOADPATH = '/user/resume/upload/';
/**
 *
 * @param {Object} payload
 * @param {File} payload.file files to be uploaded
 * @param {String} payload.userID user id if exist
 * @param {Boolean} payload.standAlonePage // TBD
 * @param {any} payload.source // TBD
 */
const upload = (payload) => {
  // replace payload with formData
  const formData = new FormData();
  Object.keys(payload).forEach((key) => {
    formData.append(key, payload[key]);
  });
  return Service.post(UPLOADPATH, formData);
};

const logUploadResumeActivity = (resumeLink) => {
  const data = {
    activityType: 'RESUME_UPLOAD',
    resumeLink,
  };
  logActivity(data);
};
export const uploadService = {
  upload,
  logUploadResumeActivity,
};
